import styled from 'styled-components';

const LegalStyle = styled.section`
	&.legal {
		--contMarg: var(--sp8x);
		--titleMarg: var(--sp4x);
		--subtitleMarg: var(--sp1x);
		--descriptionMarg: var(--sp4x);

		> section {
			margin-top: var(--contMarg);
		}

		.legalSections {
			.title {
				margin-bottom: var(--titleToText);
			}

			.subtitle {
				margin-bottom: var(--subtitleMarg);
			}

			.description {
				margin-bottom: var(--descriptionMarg);

				strong {
					font-weight: var(--ffMedium);
				}

				a {
					text-decoration: underline;
					font-weight: bold;
				}
			}
		}

		.details {
			max-width: var(--sp54x);

			.email {
				margin-bottom: var(--sp2x);
			}

			.info {
				display: flex;
				flex-direction: column;
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			--contMarg: var(--sp10x);
			--contMaxWidth: 89%;

			.legalSections {
				max-width: var(--contMaxWidth);
				margin-left: auto;
				margin-right: auto;
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			--titleMarg: var(--sp5x);
			--contMarg: var(--sp11x);
			--subtitleMarg: var(--sp2x);
			--descriptionMarg: var(--sp5x);
			--contMaxWidth: 80%;
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
			--contMaxWidth: 79%;
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
			--contMarg: var(--sp17x);
			--contMaxWidth: 82%;
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
			--contMaxWidth: 79.5%;
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			--titleMarg: var(--sp8x);
			--contMarg: var(--sp15x);
			--subtitleMarg: var(--sp3x);
			--descriptionMarg: var(--sp15x);
			--contMaxWidth: 74.5%;
		}
	}
`;

export default LegalStyle;
